/**
 * House of Places — the heart beside the product name.
 *
 * It was a dead control: a visible button with nothing bound to it (measured:
 * no DOM change, no storage, nothing on click). It now saves the poster for
 * this shopper — the heart fills, aria-pressed flips, and the choice survives
 * a reload in this browser. There is no account-wide wishlist behind it; a
 * wishlist app can take over the same [data-hop-wishlist] button later.
 *
 * Bound on the document (Dawn re-renders the info column on variant change)
 * and once per page (the quick-add modal re-runs product scripts).
 */
(function () {
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-wishlist']) return;
  yuklu['hop-wishlist'] = true;

  var ANAHTAR = 'hop-wishlist';

  function oku() {
    try {
      return JSON.parse(localStorage.getItem(ANAHTAR)) || [];
    } catch (e) {
      return [];
    }
  }

  function yaz(liste) {
    try {
      localStorage.setItem(ANAHTAR, JSON.stringify(liste));
    } catch (e) {
      /* private mode: the heart still toggles for this visit */
    }
  }

  function boya(buton, kayitli) {
    buton.setAttribute('aria-pressed', kayitli ? 'true' : 'false');
    buton.classList.toggle('is-saved', kayitli);
  }

  function tazele() {
    var liste = oku();
    document.querySelectorAll('[data-hop-wishlist]').forEach(function (b) {
      boya(b, liste.indexOf(b.getAttribute('data-hop-wishlist')) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var buton = e.target.closest('[data-hop-wishlist]');
    if (!buton) return;
    var tutamak = buton.getAttribute('data-hop-wishlist');
    var liste = oku();
    var i = liste.indexOf(tutamak);
    if (i === -1) liste.push(tutamak);
    else liste.splice(i, 1);
    yaz(liste);
    boya(buton, i === -1);
  });

  // A product that arrives later (the quick-add modal) announces itself;
  // no body-wide observer needed for that.
  document.addEventListener('product-info:loaded', tazele);

  tazele();
})();

/**
 * The wishlist app pins its heart on the corner of the product photo. The
 * client wanted the photo clean, so the heart moves beside the product name.
 * The node itself is moved (not copied), so the app's own click handler and
 * the header count keep working. Watched, because the app may draw the heart
 * after this script runs, or again after Dawn re-renders the page.
 */
(function () {
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-wishlist-move']) return;
  yuklu['hop-wishlist-move'] = true;

  function tasi() {
    document.querySelectorAll('media-gallery .wishlist-icon').forEach(function (kalp) {
      var urun = kalp.closest('.product');
      var baslik = urun && urun.querySelector('.product__info-container .product__title');
      if (!baslik || baslik.querySelector('.wishlist-icon')) return;
      kalp.classList.add('hop-title-heart');
      baslik.appendChild(kalp);
    });
  }

  tasi();
  new MutationObserver(tasi).observe(document.body, { childList: true, subtree: true });
})();
